export default "__VITE_ASSET__BCXUW8ZE__"